import { useState } from "react";

import { useForm, SubmitHandler, Controller } from "react-hook-form";

import { ProductData } from "data/product/products";
import { Button, LargeInput } from "studio-design-system";

import { collectEmail } from "~/api/userApi";
import { ImageWithBlur } from "~/components/common/ImageWithBlur/ImageWithBlur";
import { emailValidRegex } from "~/util/validateEmail";

import * as styles from "./PreviewForm.css";

export const PreviewForm = ({ productData }: { productData: ProductData }): React.ReactElement => {
  const [buttonText, setButtonText] = useState("Get access");

  const onSubmit: SubmitHandler<{
    email: string;
  }> = async (data: { email: string }) => {


    let noPriceOffer = localStorage.getItem("noPriceOffer");
    let extraTags = ["previewLessonRequested"];

    if (noPriceOffer) {
      extraTags.push("isInvalidOffer");
    }

    collectEmail({
      email: data.email,
      classInterestedIn: productData.id,
      extraTags: extraTags,
    });

    setButtonText("Sending! Check your email");
    setTimeout(() => {
      setButtonText("Get access");
    }, 4000);

    setValue("email", "");
  };

  const {
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    setValue,
  } = useForm<{
    email: string;
  }>({
    defaultValues: {
      email: "",
    },
  });

  return (
    <div className={styles.container}>
      <div className={styles.headerContainer}>
        <div className={styles.imageContainer}>
          <ImageWithBlur
            src={
              "https://res.cloudinary.com/monthly/image/upload/v1674463761/monthly-admin-images/behind-scenes-product/video-page/icon/icon1_iqarbm.svg"
            }
            alt="preview icon"
            layout={"fixed"}
            width={24}
            height={24}
          />
        </div>
        <h2 className={styles.title}>Preview a lesson for free</h2>
      </div>
      <div className={styles.relativeContainer}>
        <Controller
          control={control}
          rules={{
            pattern: {
              value: emailValidRegex,
              message:
                "This email address looks invalid. If we’re wrong, please contact support@studio.com.",
            },
            required: { value: true, message: "You must provide an email." },
          }}
          render={({ field: { onChange, value } }) => (
            <LargeInput
              type="email"
              placeholder="Enter email"
              errorMessage={errors.email?.message}
              autoComplete="email"
              onChange={onChange}
              value={value}
              className={styles.previewInput}
            />
          )}
          name="email"
        />
        <Button className={styles.button} onClick={handleSubmit(onSubmit)} isLoading={isSubmitting}>
          {buttonText}
        </Button>
      </div>
    </div>
  );
};
